import styled from "styled-components";
import { AuthoryColorSchemes } from "../ProfileHero/V3ProfileHero.types";
import ContentEditable from "react-contenteditable";
import { hexToRgba } from "../../utils/hexToRGBA";
import { AuthoryColorSchemeProps, getFontColor } from "../ReusableStyledComponents/FontSetUtilities";
import { SharedOutline, SharedOutlineStyles } from "../ReusableStyledComponents/outline";

export const GenericContentEditableWrapper = styled(ContentEditable) <{ $dashOnHover: boolean,  $editMode?: boolean, placeholder: string } & AuthoryColorSchemeProps>`
    padding: ${({ $editMode }) =>  $editMode ? "4px": undefined};

    ${SharedOutlineStyles}

    &[contenteditable="true"] {
        cursor: text;
        border-radius: 8px;
        display: inline-block;

        &:focus {
            ${SharedOutline}
        }

        &:empty:before {
            content: attr(placeholder);
            display: block;
            color: ${({ $colorVariant, $customBackgroundColor, theme}) => {
                if ($colorVariant === AuthoryColorSchemes.userTheme) {
                    return hexToRgba(getFontColor($customBackgroundColor || theme.customization.backgroundColor, $colorVariant ), 0.3);
                } else {
                    return hexToRgba("#FFFFFF",  0.3 );
                }
            }};
        }
    }
`;